// Test - Base-Url
// export const BASE_URL = "http://localhost:7007/api/";


// Production  Base-Url
// export const BASE_URL = "https://api.acediva.in/api/";
// export const BASE_URL = "https://ecommerce-backend-three-delta.vercel.app/api/";
// export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const BASE_URL="https://webapi.bigbangcrackers.com/api/"

//  export const BASE_URL="http://localhost:7007/api/"
 export const IMAGE_BASE_URL = "https://webapi.bigbangcrackers.com";